import yaml from 'js-yaml';

export function parseYaml(text: string): unknown {
  return yaml.load(text);
}

export function dumpYaml(obj: unknown): string {
  return yaml.dump(obj, {
    indent: 2,
    lineWidth: 120,
    noRefs: true,
    sortKeys: false,
  });
}
